import { Stack } from '@fluentui/react';
import { useThemeData } from '@msrceng/theme';
import { getSearchListStyle } from './getSearchListStyle';
import { SearchFilter } from './SearchFilter';
import { useSearchListData } from './SearchListContext';
import { SearchListTableCommandBar } from './TableCommandBar';
import { OrderByAnnounced } from './OrderByAnnounced/OrderByAnnounced';

/** This is the overall UX of the whole search cluster (including all filtering and buttons).
 * > This component should avoid state management aggressively!
 */
export const SearchListLayout = ({ children }) => {
  const { theme } = useThemeData();
  const { allColumnList, fullPage, hideCommandBar, isFilterVisible, orderBy } =
    useSearchListData();

  return (
    <Stack
      horizontalAlign='stretch'
      tokens={{ childrenGap: 0 }}
      style={getSearchListStyle(theme)}
      styles={{
        root: {
          height: fullPage ? '80vh' : 'unset',
        },
      }}
    >
      <OrderByAnnounced allColumnList={allColumnList} orderBy={orderBy} />
      {!hideCommandBar && <SearchListTableCommandBar />}
      <SearchFilter visible={isFilterVisible} hideCommandBar={hideCommandBar} />

      {children}
    </Stack>
  );
};
